import React, { useState, useEffect, useRef } from "react";
import DrawMap from "../common/drawmap";
import SweetAlert from "react-bootstrap-sweetalert";
import redirectURL from "../redirectURL"; // Assuming redirectURL is an axios instance
import { useParams, useLocation } from "react-router-dom";
import moment from "moment";
import TimelineModal from './TimelineModal.js';
import './trackingLink.css';
import SearchIcon from "../../assets/icons/search-icon.svg";
import LegrandLogo from '../../assets/icons/legrand.png'
import NumericLogo from '../../assets/icons/Numeric.png'
import IndoAsianLogo from '../../assets/icons/Indoasian.png'
import PoweredByEnmovil from "../../assets/icons/poweredByEnmovil.svg";


import { fetchGridLayout, getHyphenDDMMMYYYYHHMM, getDDMMMYYYY, saveGridLayout, getHyphenDDMMYYYYHHMMSS, getHyphenYYYYMMDDHHMMSS } from '../common/utils';


const TrackingConsignments = () => {
  //Invoice based tracking
  {/* const { invoiceno, "*": invoiceSeries } = useParams();
  const fullInvoiceNo = invoiceSeries          
    ? `${invoiceno}/${invoiceSeries}` 
    : invoiceno; */}

  //LR based tracking
  // const { prefix, lrno } = useParams(); // contains both lr_no and dispatch_date
  const { lrno, entityType } = useParams();
  // console.log("URL PARAMS:", {
  //   lrno,
  //   entityType
  // });
  const [lrNoOnly, setLrNoOnly] = useState("");
  const [dispatchDate, setDispatchDate] = useState("");
  const [isNumericEntity, setIsNumericEntity] = useState(false);
  var [consignmentNum, setConsignmentNum] = useState("");
  var [routeTruck, setrouteTruck] = useState({
    truck_no: "",
    startTime: "",
    endTime: "",
  });
  var [loadshow, setloadshow] = useState("show-n");
  var [overly, setOverlay] = useState("show-n");
  var [maptruckno, setMaptruckno] = useState([]);
  var [rowMapRoute, setrowMapRoute] = useState([]);
  var [googelRoutes, setgoogelRoutes] = useState([]);
  var [tolls, setTolls] = useState([]);
  var [dealer, setDealer] = useState([]);
  var [mapinfo, setmapinfo] = useState([]);
  var [defTransitCoords, setdefTransitCoords] = useState([]);
  var [devation_flag, setdevation_flag] = useState(0);
  var [baseRouteCoords, setbaseRouteCoords] = useState([]);
  const [show, setShow] = useState(false)
  const [title, setTitle] = useState('')
  const [type, setType] = useState('default')
  const [secondShow, setSecondShow] = useState('show-n')
  const [showDetails, setShowDetails] = useState('show-n')
  const [inboxSlider, setInboxSlider] = useState('')
  const [timelineData, setTimelineData] = useState([]);
  const [reversedTimelineData, setReversedTimelineData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [trackingMap, setTrackingMap] = useState(false);
  const [showInvoiceDetails, setShowInvoiceDetails] = useState({
    transporter_name: "",
    total_weight: "",
    total_cbm: "",
    pod_status: ""
  });

  const [trackingId, setTrackingId] = useState("");
  const [selectedRecord, setSelectedRecord] = useState("");
  const [estimatedETA, setEstimatedETA] = useState("");
  const [eventDateNTime, setEventDateNTime] = useState("");
  const [eventLocation, setEventLocation] = useState("");
  const [updatedStatus, setUpdatedStatus] = useState("");
  const [lrNo, setLrNo] = useState('');
  const [sliderRouteTranslate, setSliderRouteTranslate] = useState("");
  const [invoiceNo, setInvoiceNo] = useState('')
  const [expandedLegsIndex, setExpandedLegsIndex] = useState(null);
  const [actualDeliveryDate, setActualDeliveryDate] = useState("");
  const [deliveryDate, setDeliveryDate] = useState("");
  const [activeTab, setActiveTab] = useState("tracking");
  const [captchaText, setCaptchaText] = useState("");
  const [enteredCaptcha, setEnteredCaptcha] = useState("");
  const [captchaVerified, setCaptchaVerified] = useState(false);
  const captchaCanvasRef = useRef(null);

  const statusImageMap = {
    "trip created": require("../../assets/icons/dispatch.png"),
    "dispatched from source": require("../../assets/icons/dispatch.png"),
    "in transit": require("../../assets/icons/transit.png"),
    "near destination": require("../../assets/icons/arrived.png"),
    "arrived at destination": require("../../assets/icons/arrived.png"),
    "out for delivery": require("../../assets/icons/out_for_delivery.png"),
    "delivered": require("../../assets/icons/delivered.png"),
    "undelivered": require("../../assets/icons/delivered.png"),
    "Booked": require("../../assets/icons/dispatch.png"),
    // "Un-delivered": require("../../assets/icons/undelivered.png"),
  };
  const statusImageMapForTable = {
    "tripcreated": require("../../assets/icons/dispatch.png"),
    "dispatchedfromsource": require("../../assets/icons/dispatch.png"),
    "intransit": require("../../assets/icons/transit.png"),
    "neardestination": require("../../assets/icons/arrived.png"),
    "arrivedatdestination": require("../../assets/icons/arrived.png"),
    "outfordelivery": require("../../assets/icons/out_for_delivery.png"),
    "delivered": require("../../assets/icons/delivered.png"),
    "undelivered": require("../../assets/icons/delivered.png"),
    "booked": require("../../assets/icons/dispatch.png"),
    // "Un-delivered": require("../../assets/icons/undelivered.png"),
  };

  const statusImageMapInactive = {
    "trip created": require("../../assets/icons/dispatch.png"),


    "in transit": require("../../assets/icons/transit_inactive.png"),
    "near destination": require("../../assets/icons/arrived_inactive.png"),
    "dispatched from source": require("../../assets/icons/dispatch.png"),
    "arrived at destination": require("../../assets/icons/arrived_inactive.png"),
    "out for delivery": require("../../assets/icons/out_for_delivery_inactive.png"),
    "delivered": require("../../assets/icons/delivered_inactive.png"),
    "undelivered": require("../../assets/icons/delivered_inactive.png"),
  }
  const statusForTracking = ["Dispatched from Source", "In Transit", "Arrived At Destination", "Undelivered", "Out For Delivery", "Delivered"]

  const statusForTrackingForMobile = [...statusForTracking].reverse()


  var [validStatus, setSelectedValidStatus] = useState([])
  var [reversedValidStatus, setReversedValidStatus] = useState([])
  const [viewOption, setViewOption] = useState("invoice")
  var [statusMap, setStatusMap] = useState({
    0: "at source",
    1: "dispatched from source",
    2: "in transit",
    3: "arrived at destination",
    4: "out for delivery",
    5: "delivered",
    8: "delivered",
    10: "Trip Created",
    11: "undelivered"
  })




  const generateCaptcha = () => {
    const chars =
      "ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz23456789";
    let result = "";
    for (let i = 0; i < 7; i++) {
      result += chars.charAt(
        Math.floor(Math.random() * chars.length)
      );
    }
    setCaptchaText(result);
  };

  useEffect(() => {
    generateCaptcha();
  }, []);

  useEffect(() => {
    if (!captchaText || !captchaCanvasRef.current) return;
    const canvas = captchaCanvasRef.current;
    const ctx = canvas.getContext("2d");
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.fillStyle = "#f5f5f5";
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    // Noise Lines
    for (let i = 0; i < 8; i++) {
      ctx.beginPath();
      ctx.moveTo(
        Math.random() * canvas.width,
        Math.random() * canvas.height
      );

      ctx.lineTo(
        Math.random() * canvas.width,
        Math.random() * canvas.height
      );

      ctx.strokeStyle =
        "#" +
        Math.floor(Math.random() * 16777215).toString(16);

      ctx.stroke();
    }
    // Noise Dots
    for (let i = 0; i < 120; i++) {
      ctx.fillStyle =
        "#" +
        Math.floor(Math.random() * 16777215).toString(16);

      ctx.fillRect(
        Math.random() * canvas.width,
        Math.random() * canvas.height,
        2,
        2
      );
    }
    // Draw Characters
    captchaText.split("").forEach((char, index) => {
      const x = 20 + index * 25;
      const y = 45;
      ctx.save();
      ctx.translate(x, y);
      ctx.rotate(
        (Math.random() - 0.5) * 0.7
      );
      ctx.font = "bold 30px Arial";
      ctx.fillStyle =
        "#" +
        Math.floor(Math.random() * 16777215).toString(16);
      ctx.fillText(char, 0, 0);
      ctx.restore();
    });
  }, [captchaText]);

  const verifyCaptcha = () => {
    if (
      enteredCaptcha.trim().toUpperCase() ===
      captchaText.toUpperCase()
    ) {
      setCaptchaVerified(true);
      fetchAndLogDetails();
    } else {
      setShow(true);
      setTitle("Invalid CAPTCHA");
      setType("danger");

      setEnteredCaptcha("");
      generateCaptcha(); // generate new captcha
    }
  };


  //   useEffect(() => {
  //     const fetchAndLogDetails = async () => {
  //       setloadshow("show-m")
  //       try {
  //         console.log("useEffect is triggered.");
  //         console.log("Params value:", invoiceNo);

  //         setloadshow("show-m");
  //         setrowMapRoute([]);
  //         setTolls([]);
  //         setdefTransitCoords([]);
  //         setgoogelRoutes([]);
  //         // Base64 decoding with error handling
  //         var decodedValue;
  //         var record;
  //         try {
  //           decodedValue = invoiceNo;
  //           var params ={
  //             invoice_no: invoiceNo
  //           }
  //           const response = await redirectURL.post("/consignments/getinvoicerecord",params);
  //           console.log(response, "response123");
  //           if (response.data.length ===0){
  //             setShow(true);
  //             setTitle("No Truck data available")
  //             setType("danger")
  //           }
  //           record = response.data[0];

  //         } catch (error) {
  //           console.error("Error decoding Base64 value:", error);
  //           setBasicTitle("Invalid Data");
  //           setBasicType("error");
  //           setShow(true);
  //           return;
  //         }

  //         const req_uri = decodedValue;
  //         console.log(req_uri, "req_uri123");

  // console.log(record, "test1");

  //         if(record.tracking_type==="PTL"){
  //             onShowCourierTrack(record)
  //             setTrackingMap(false)

  //         }else{
  //           if(record.manual_tracking===1 && record.manual_tracking !==undefined){
  //             onShowFtlTrack(record.shipment_id)
  //             setTrackingMap(false)

  //           }else{
  //             setTrackingMap(true)
  //             var current_date = new Date();
  //             current_date = new Date(current_date.setHours(current_date.getHours() - 1));

  //             var gateouttime = moment.parseZone(record.gate_out_time).format('YYYY-MM-DD HH:mm:ss');
  //             var s_date;
  //                     if (record.gate_out_time !=="" && record.gate_out_time !== undefined){
  //                          s_date = moment.parseZone(record.gate_out_time).format('YYYY-MM-DD HH:mm:ss');
  //                     }else{
  //                         s_date = moment.parseZone(record.shipment_time).format('YYYY-MM-DD HH:mm:ss');
  //                     }

  //             var end_date;
  //             var edate;
  //             if (record.hasOwnProperty('status')) {
  //                 console.log(record.status, "Statusssss");
  //                 if (record.status == 6) {
  //                     if (record.force_closure_time) {
  //                         let splitT = record.force_closure_time.split('T');
  //                         let yMD = splitT[0];
  //                         let hMS = splitT[1];
  //                         let hms1 = hMS.split('.');
  //                         let finalHms = hms1[0];
  //                         let final_end_date = yMD + ' ' + finalHms;
  //                         end_date = final_end_date;
  //                         edate = final_end_date;
  //                         console.log("edate", edate);
  //                     }
  //                 } else if (record.status == 2 || record.status == 3) {
  //                     end_date = moment.parseZone().format('YYYY-MM-DD HH:mm:ss');
  //                     edate = getHyphenDDMMYYYYHHMMSS(end_date);
  //                 } else if (record.status == 5) {
  //                     if (record.left_dealer_marked) {
  //                         end_date = record.left_dealer_marked.replace("T", " ").replace("Z", " ").replace(".000", " ").replace(".855", " ").trim();
  //                         edate = getHyphenDDMMYYYYHHMMSS(record.left_dealer_marked);
  //                     }
  //                 } else if (record.status == 4 || record.status == 8) {
  //                     if (record.recent_dealer_reported) {
  //                         end_date = record.recent_dealer_reported.replace("T", " ").replace("Z", " ").replace(".000", " ").trim();
  //                         edate = getHyphenDDMMYYYYHHMMSS(record.recent_dealer_reported);
  //                     }
  //                 } else {
  //                     end_date = moment.parseZone().format('YYYY-MM-DD HH:mm:ss');
  //                     edate = getHyphenDDMMYYYYHHMMSS(end_date);
  //                     // console.log("edate", edate);
  //                 }

  //                 if (!end_date) {
  //                     end_date = moment.parseZone().format('YYYY-MM-DD HH:mm:ss');
  //                 }
  //             }

  //             const truck_no = record.truck_no;
  //             const from_date = gateouttime;
  //             const to_date = end_date;
  //             // const consignee_code = req_uri[3];
  //             const consignment_code = record.consignment_code;
  //             // const consignment_code1 = req_uri[3];
  //             const consignee_code = record.consignee_code;
  //             setConsignmentNum(consignment_code);
  //             setMaptruckno(truck_no);
  //             setrouteTruck({
  //               truck_no: truck_no,
  //               startTime: from_date,
  //               endTime: to_date,
  //             });
  //             setDealer(consignee_code);
  //             console.log("Decoded Values: ", {
  //               truck_no,
  //               from_date,
  //               to_date,
  //               consignment_code,
  //             });

  //             const reqData = {
  //               truck_no,
  //               gate_out_time: s_date,
  //               seconddate: to_date,
  //               consignment_code,
  //               screen: "consignment",
  //               // value: "sentemail",
  //               // email: "sobha@gmail.com",
  //               // map_link: "vffefekdwedwj",
  //             };
  //             // console.log(reqData, "reqData");

  //             const response = await redirectURL.post("/consignments/maproutes", 
  //               reqData
  //             );

  //             var records = response.data;
  //             setloadshow("show-n");

  //             if (Array.isArray(records.coords) && records.coords.length>0) {
  //               setmapinfo(records);
  //               setdevation_flag(0);
  //             } else if (records.coords && records.coords.length === 0) {

  //               setShow(true);
  //               setTitle("No data available");
  //               setType("danger");
  //             } else {

  //               setShow(true);
  //               setTitle("No Truck data available");
  //               setType("danger");
  //             }
  //         }

  //         // if (req_uri.length < 5) {
  //         //   console.error("Decoded value does not contain enough parameters.");
  //         //   setBasicTitle("Invalid Parameters");
  //         //   setBasicType("error");
  //         //   setShow(true);
  //         //   return;
  //         // }
  //           }



  //         // console.log("Response records:", records);
  //       } catch (error) {
  //         console.error("Error fetching map routes:", error);
  //       }
  //     };

  //     // Trigger the function

  //     fetchAndLogDetails();
  //   }, [invoiceNo]);

  //Invoice Based Tracking
  {/* useEffect(() => {
    if (fullInvoiceNo) {
      setInvoiceNo(fullInvoiceNo);    
      setViewOption("invoice");
    }
  }, [fullInvoiceNo]);                         

  useEffect(() => {
    if (invoiceNo && viewOption === "invoice") {
      fetchAndLogDetails(invoiceNo); 
    }
  }, [invoiceNo, viewOption]); */}

  //LR based tracking
  // useEffect(() => {
  //   if (lrno) {
  //     setLrNo(lrno);
  //     setViewOption("lr");
  //   }
  // }, [lrno]);

  // useEffect(() => {
  //   if (lrNo && viewOption === "lr") {
  //     fetchAndLogDetails(); 
  //   }
  // }, [lrNo, viewOption]);

  //LR with Dispatch date based tracking
  // useEffect(() => {
  //   if (lrno) {
  //     const [lr, rawDate] = lrno.split("_");
  //     setLrNo(prefix ? `${prefix}/${lr}` : lr);

  //     if (rawDate?.length === 8) {
  //       const day = rawDate.slice(0, 2);
  //       const month = rawDate.slice(2, 4);
  //       const year = rawDate.slice(4, 8);
  //       const isoDate = `${year}-${month}-${day}`; // convert to ISO
  //       const formattedDate = getDDMMMYYYY(isoDate);
  //       setDispatchDate(formattedDate);
  //     } else {
  //       setDispatchDate(""); // fallback if format wrong
  //     }
  //     setViewOption("lr");
  //   }
  // }, [lrno]);
  // useEffect(() => {
  //   if (!lrno) return;
  //   if (entityType?.toUpperCase() === "NUMERIC") {
  //     // console.log("NUMERIC ENTITY DETECTED");
  //     setIsNumericEntity(true);
  //     const value = lrno?.toString();
  //     if (value?.includes("/")) {
  //       // console.log("SETTING INVOICE:", value);
  //       setInvoiceNo(value);
  //       setViewOption("invoice");
  //     }
  //     else {
  //       // console.log("SETTING LR:", value);
  //       setLrNo(value);
  //       setDispatchDate("");
  //       setViewOption("lr");
  //     }
  //     return;
  //   }
  //   setIsNumericEntity(false);
  //   const [lr, rawDate] = lrno.split("_");
  //   setLrNo(lr);
  //   if (rawDate?.length === 8) {
  //     const day = rawDate.slice(0, 2);
  //     const month = rawDate.slice(2, 4);
  //     const year = rawDate.slice(4, 8);
  //     const isoDate = `${year}-${month}-${day}`;
  //     const formattedDate = getDDMMMYYYY(isoDate);
  //     setDispatchDate(formattedDate);
  //   } else {
  //     setDispatchDate("");
  //   }
  //   setViewOption("lr");
  // }, [lrno, entityType]);
  // useEffect(() => {
  //   if (!lrno) return;
  //   // NUMERIC => LR API
  //   if (entityType?.toUpperCase() === "NUMERIC") {
  //     setIsNumericEntity(true);
  //     setLrNo(lrno);
  //     setDispatchDate("");
  //     setViewOption("lr");
  //     return;
  //   }
  //   // Any other entityType (NSI, JSI, etc.) => Invoice API
  //   if (entityType) {
  //     setInvoiceNo(`${lrno}/${entityType}`);
  //     setViewOption("invoice");
  //     return;
  //   }
  //   // Pure number URL
  //   setIsNumericEntity(true);
  //   setLrNo(lrno);
  //   setDispatchDate("");
  //   setViewOption("lr");
  // }, [lrno, entityType]);
  useEffect(() => {
    if (!lrno) return;
    // NUMERIC entity
    if (entityType?.toUpperCase() === "NUMERIC") {
      setIsNumericEntity(true);
      setLrNo(lrno);
      setDispatchDate("");
      setViewOption("lr");
      return;
    }
    // NSI / JSI / etc => Invoice API
    if (entityType) {
      setIsNumericEntity(false);
      setInvoiceNo(`${lrno}/${entityType}`);
      setViewOption("invoice");
      return;
    }
    // Pure numeric LR
    if (/^\d+$/.test(lrno)) {
      setIsNumericEntity(true);
      setLrNo(lrno);
      setDispatchDate("");
      setViewOption("lr");
      return;
    }
    setIsNumericEntity(false);
    const [lr, rawDate] = lrno.split("_");
    setLrNo(lr);
    if (rawDate?.length === 8) {
      const day = rawDate.slice(0, 2);
      const month = rawDate.slice(2, 4);
      const year = rawDate.slice(4, 8);
      const isoDate = `${year}-${month}-${day}`;
      const formattedDate = getDDMMMYYYY(isoDate);
      setDispatchDate(formattedDate);
    } else {
      setDispatchDate("");
    }
    setViewOption("lr");
  }, [lrno, entityType]);
  // useEffect(() => {
  //   if (lrNo && dispatchDate && viewOption === "lr") {
  //     fetchAndLogDetails();
  //   }
  // }, [lrNo, dispatchDate, viewOption]);
  // useEffect(() => {
  //   if (viewOption === "lr") {
  //     if (isNumericEntity && lrNo) {
  //       fetchAndLogDetails();
  //       return;
  //     }
  //     if (!isNumericEntity && lrNo && dispatchDate) {
  //       fetchAndLogDetails();
  //       return;
  //     }
  //   }
  //   if (viewOption === "invoice" && invoiceNo) {
  //     fetchAndLogDetails();
  //   }
  // }, [viewOption, lrNo, dispatchDate, invoiceNo, isNumericEntity]);
// useEffect(() => {
//   if (
//     (viewOption === "lr" && lrNo) ||
//     (viewOption === "invoice" && invoiceNo)
//   ) {
//     setShowCaptcha(true);
//   }
// }, [viewOption, lrNo, dispatchDate, invoiceNo, isNumericEntity]);

  const handleViewChange = (e) => {
    setViewOption(e.target.value)
    setLrNo("")
    setInvoiceNo("")
    setSelectedValidStatus([])
    setReversedValidStatus([])
    setTimelineData([])
    setReversedTimelineData([])
    setEstimatedETA("")
    setTrackingId("")
    setShowInvoiceDetails({
      transporter_name: "",
      total_weight: "",
      total_cbm: "",
      pod_status: ""
    })


  }
  const fetchAndLogDetails = async () => {
    try {
      setloadshow("show-m");
      setrowMapRoute([]);
      setTolls([]);
      setdefTransitCoords([]);
      setgoogelRoutes([]);
      // Base64 decoding with error handling
      var decodedValue;
      var record;
      var response;
      // try {
      //   decodedValue = viewOption === "invoice" ? invoiceNo : lrNo;
      //   if (viewOption === "invoice") {
      //     const params = {
      //       invoice_no: invoiceNo
      //     }
      //     response = await redirectURL.post("/consignments/getinvoicerecord", params);
      //     record = response.data[0];


      //   } else {
      //     // const params = {
      //     //   lr_no: lrNo,
      //     //   dispatch_date: dispatchDate,
      //     // }
      //     let params = {
      //       lr_no: lrNo
      //     };

      //     if (!isNumericEntity) {
      //       params.dispatch_date = dispatchDate;
      //     }
      //     response = await redirectURL.post("/consignments/getlrrecord", params);
      //     record = response.data;


      //   }
      //   if (response.data.length === 0) {
      //     setTimelineData([])
      //     setReversedTimelineData([])
      //     setSelectedValidStatus([])
      //     setReversedValidStatus([])
      //     setShow(true);
      //     setTitle("Data not available")
      //     setType("danger")
      //   }

      // } catch (error) {
      //   console.error("Error decoding Base64 value:", error);
      //   setTitle("Invalid Data");
      //   setType("danger");
      //   setShow(true);
      //   return;
      // }
      try {
        decodedValue = viewOption === "invoice" ? invoiceNo : lrNo;
        if (viewOption === "invoice") {
          const params = {
            invoice_no: invoiceNo
          };
          response = await redirectURL.post("/consignments/getinvoicerecord", params);
          record = response.data[0];
        } else {
          let params = {
            lr_no: lrNo
          };
          if (!isNumericEntity) {
            params.dispatch_date = dispatchDate;
          }
          response = await redirectURL.post("/consignments/getlrrecord", params);
          record = response.data;

          if (
            entityType?.toUpperCase() === "NUMERIC" &&
            record &&
            record.truck_seal_entity &&
            record.truck_seal_entity.toUpperCase() !== "NUMERIC"
          ) {
            setTimelineData([]);
            setReversedTimelineData([]);
            setSelectedValidStatus([]);
            setReversedValidStatus([]);
            setShow(true);
            setTitle("Data not available");
            setType("danger");
            return;
          }
          if (
            isNumericEntity &&
            (
              !record ||
              (Array.isArray(record) && record.length === 0)
            )
          ) {
            // console.log("LR not found — trying Invoice API");
            const invoiceParams = { invoice_no: lrNo };
            const invoiceResponse = await redirectURL.post("/consignments/getinvoicerecord", invoiceParams);
            if (invoiceResponse.data && invoiceResponse.data.length > 0) {
              // console.log("Invoice record found");
              setViewOption("invoice");
              record = invoiceResponse.data[0];
              response = invoiceResponse;
            }
          }
        }

        if (!record || (Array.isArray(response.data) && response.data.length === 0)) {
          setTimelineData([]);
          setReversedTimelineData([]);
          setSelectedValidStatus([]);
          setReversedValidStatus([]);
          setShow(true);
          setTitle("Data not available");
          setType("danger");
          return;
        }
      } catch (error) {
        console.error("Error decoding Base64 value:", error);
        setTitle("Invalid Data");
        setType("danger");
        setShow(true);
        return;
      }

      const req_uri = decodedValue;
      // console.log(record, "fetched recordss");

      setSelectedRecord(record)

      // if (viewOption === "lr") {
      //   setTrackingId(record.lr_no)
      // } else {
      //   setTrackingId(record.invoice_no)
      // }
      if (isNumericEntity) {
        setTrackingId(lrno);
      } else {
        setTrackingId(
          viewOption === "lr"
            ? record.lr_no
            : record.invoice_no
        );
      }
      setShowInvoiceDetails({
        transporter_name: record.transporter_name,
        total_weight: record.total_weight,
        total_cbm: record.total_cbm,
        pod_status: (record.pod_status ? "Yes" : "No")
      })
      setEventDateNTime(record.last_event_time)
      setEventLocation(record.last_location)


      if (record.tracking_type === "PTL") {
        setEstimatedETA(record.revised_eta)
        setUpdatedStatus(record.consignment_status)
        onShowCourierTrack(record)
        setTrackingMap(false)
        setSliderRouteTranslate("")
        // setLrNo(record.lr_no)
        setActualDeliveryDate(record.actual_delivery_date || "");
        setDeliveryDate(record.delivery_date || "");


      } else if (record.tracking_type === "FTL") {
        setEstimatedETA(record.revised_trip_end)
        setActualDeliveryDate(record.actual_delivery_date || "");
        setDeliveryDate(record.delivery_date || "");

        if (!!statusMap[record.status]) {
          setUpdatedStatus(statusMap[record.status])
        } else {
          setUpdatedStatus("")
        }


        onShowFtlTrack(record)
        setTrackingMap(false)
        setSliderRouteTranslate("")
        // setLrNo(record.lr_no)



        if (record.manual_tracking !== 1 && record.manual_tracking === undefined) {
          setTrackingMap(true)
          setSliderRouteTranslate("slider-translate-60p")
          // setLrNo(record.lr_no)

          var current_date = new Date();
          current_date = new Date(current_date.setHours(current_date.getHours() - 1));

          var gateouttime = moment.parseZone(record.gate_out_time).format('YYYY-MM-DD HH:mm:ss');
          var s_date;
          if (record.gate_out_time !== "" && record.gate_out_time !== undefined) {
            s_date = moment.parseZone(record.gate_out_time).format('YYYY-MM-DD HH:mm:ss');
          } else {
            s_date = moment.parseZone(record.shipment_time).format('YYYY-MM-DD HH:mm:ss');
          }

          var end_date;
          var edate;
          if (record.hasOwnProperty('status')) {
            if (record.status == 6) {
              if (record.force_closure_time) {
                let splitT = record.force_closure_time.split('T');
                let yMD = splitT[0];
                let hMS = splitT[1];
                let hms1 = hMS.split('.');
                let finalHms = hms1[0];
                let final_end_date = yMD + ' ' + finalHms;
                end_date = final_end_date;
                edate = final_end_date;
              }
            } else if (record.status == 2 || record.status == 3) {
              end_date = moment.parseZone().format('YYYY-MM-DD HH:mm:ss');
              edate = getHyphenDDMMYYYYHHMMSS(end_date);
            } else if (record.status == 5) {
              if (record.left_dealer_marked) {
                end_date = record.left_dealer_marked.replace("T", " ").replace("Z", " ").replace(".000", " ").replace(".855", " ").trim();
                edate = getHyphenDDMMYYYYHHMMSS(record.left_dealer_marked);
              }
            } else if (record.status == 4 || record.status == 8) {
              if (record.recent_dealer_reported) {
                end_date = record.recent_dealer_reported.replace("T", " ").replace("Z", " ").replace(".000", " ").trim();
                edate = getHyphenDDMMYYYYHHMMSS(record.recent_dealer_reported);
              }
            } else {
              end_date = moment.parseZone().format('YYYY-MM-DD HH:mm:ss');
              edate = getHyphenDDMMYYYYHHMMSS(end_date);
              // console.log("edate", edate);
            }

            if (!end_date) {
              end_date = moment.parseZone().format('YYYY-MM-DD HH:mm:ss');
            }
          }

          const truck_no = record.truck_no;
          const from_date = gateouttime;
          const to_date = end_date;
          // const consignee_code = req_uri[3];
          const consignment_code = record.consignment_code;
          // const consignment_code1 = req_uri[3];
          const consignee_code = record.consignee_code;
          setConsignmentNum(consignment_code);
          setMaptruckno(truck_no);
          setrouteTruck({
            truck_no: truck_no,
            startTime: from_date,
            endTime: to_date,
          });
          setDealer(consignee_code);


          const reqData = {
            truck_no,
            gate_out_time: s_date,
            seconddate: to_date,
            consignment_code,
            screen: "consignment",
            // value: "sentemail",
            // email: "sobha@gmail.com",
            // map_link: "vffefekdwedwj",
          };
          // console.log(reqData, "reqData");

          const response = await redirectURL.post("/consignments/maproutes",
            reqData
          );

          var records = response.data;
          setloadshow("show-n");

          if (Array.isArray(records.coords) && records.coords.length > 0) {
            setmapinfo(records);
            setdevation_flag(0);
          } else if (records.coords && records.coords.length === 0) {

            setShow(true);
            setTitle("No data available");
            setType("danger");
          } else {

            setShow(true);
            setTitle("No Truck data available");
            setType("danger");
          }
        }

        // if (req_uri.length < 5) {
        //   console.error("Decoded value does not contain enough parameters.");
        //   setBasicTitle("Invalid Parameters");
        //   setBasicType("error");
        //   setShow(true);
        //   return;
        // }
      }



      // console.log("Response records:", records);
    } catch (error) {
      console.error("Error fetching map routes:", error);
    }
  }
  const resetTrackingData = () => {
    setShowModal(false)
    setTimelineData([])
    setReversedTimelineData([])
    setSliderRouteTranslate("")
    setTrackingMap(false)
    setmapinfo([])
    setLrNo("")
    setMaptruckno([])
    setrouteTruck({
      truck_no: "",
      startTime: "",
      endTime: ""
    })
    setDealer([])
    setInvoiceNo("")

  }
  const settingValidStatus = (data, status) => {
    const hasUndelivered = data.some(
      item => normalizeStatus(item.intransit_status).includes("undelivered")
    );

    const filteredStatus = hasUndelivered || (status.toLowerCase() === "undelivered")
      ? statusForTracking
      : statusForTracking.filter(status => normalizeStatus(status) !== "undelivered");
    // console.log(filteredStatus, "filteredStatusss999");
    const filteredStatusForMobile = hasUndelivered || (status.toLowerCase() === "undelivered")
      ? statusForTrackingForMobile
      : statusForTrackingForMobile.filter(status => normalizeStatus(status) !== "undelivered");

    setSelectedValidStatus(filteredStatus)
    setReversedValidStatus(filteredStatusForMobile)
  }

  const onShowCourierTrack = async (params) => {
    try {
      const response = await redirectURL.post('/consignments/trackcourier', { consignment_code: params.consignment_code, shipment_id: params.shipment_id });
      if (response.data.consignments?.length > 0) {
        let data = response.data.consignments;
        settingValidStatus(data, params.consignment_status)

        setTimelineData(response.data.consignments);
        setReversedTimelineData([...data].reverse())
        setShowModal(true); // Show modal on success

      } else {
        setTimelineData([]);
        setReversedTimelineData([])
      }
    } catch (error) {
      console.error("Error fetching consignment data: ", error);
    }
  };
  const onShowFtlTrack = async (params) => {
    try {
      const response = await redirectURL.post('/consignments/trackftlconsignments', { shipment_id: params.shipment_id, tpt_category: params.tpt_category });
      if (response.data.consignments?.length > 0) {
        let data = response.data.consignments;
        if (!!statusMap[params.status]) {
          settingValidStatus(data, statusMap[params.status])
        } else {
          setSelectedValidStatus([])
          setReversedValidStatus([])

        }

        setTimelineData(response.data.consignments);
        setReversedTimelineData([...data].reverse())
        setShowModal(true); // Show modal on success
      } else {
        setTimelineData([]);
        setReversedTimelineData([])
      }
    } catch (error) {
      console.error("Error fetching consignment data: ", error);
    }
  };
  const closeAlert = () => {
    setShow(false);
    setloadshow("show-n");
    setOverlay("show-n");
  };
  const onCloseModal = () => {
    setShowModal(false); // Close the modal
  }

  const onClickHideAll = () => {
    // console.log("X is clicked");
    setrowMapRoute([]);
    setTolls([]);
    setgoogelRoutes([]);
    setMaptruckno([]);
  };
  const onConfirm = () => {
    setShow(false);
    // setLoader(false)
  };
  const onClickShowDetails = () => {
    // console.log("check_entering")
    setSecondShow('show-m')
    setOverlay('show-m')
    setShowDetails('show-m')
    setInboxSlider('slider-translatey')

  }
  const onClickHideAll1 = () => {
    setloadshow('show-n')
    setOverlay('show-n')
    setSecondShow('show-n')
    setInboxSlider('')
  }


  const latestMatchedStatus = timelineData.length
    ? timelineData[timelineData.length - 1].intransit_status
    : null;


  const normalizeStatus = (status) =>
    status?.replace(/[\s-]/g, "").toLowerCase();

  // const onShowPod = () => {
  //   let params = {
  //     uploaded_document: selectedRecord.uploaded_pod_document,
  //     lr_no: selectedRecord.lr_no
  //   }
  //   redirectURL.post("/consignments/downloadUploadDocument", params)
  //     .then(res => {

  //       const data = res.data[0]
  //       if (data?.url) {
  //         window.open(data.url, "_blank");
  //       }



  //     })
  //     .catch(error => {
  //       console.error(error);
  //     });
  // }

  const onDownloadPod = async () => {
    try {
      const uploadedDocs = selectedRecord?.uploaded_pod_document;
      if (!Array.isArray(uploadedDocs) || uploadedDocs.length === 0) {
        alert("No POD document found");
        return;
      }
      const fileObj = uploadedDocs[0];
      const fileName = fileObj?.fileName;
      if (!fileName) {
        alert("File name is missing");
        return;
      }
      const response = await redirectURL.post(
        '/consignments/podDownloadDocument',
        { fileName },
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );
      const signedUrl = response.data?.url;
      if (!signedUrl) {
        throw new Error("Signed URL missing in response");
      }

      const link = document.createElement('a');
      link.href = signedUrl;
      link.download = fileName.split('/').pop();
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

    } catch (error) {
      console.error("❌ Download error:", error.message, error);
      alert("Download failed. Please try again.");
    }
  };

  const entity = selectedRecord?.truck_seal_entity?.toLowerCase() || "";

  let logo = null; // default
  let logoStyle = {}; // default style

  if (entity.includes("numeric")) {
    logo = NumericLogo;
    logoStyle = { height: "71px", width: "150px" };
  } else if (entity.includes("indoasian")) {
    logo = IndoAsianLogo;
    logoStyle = { height: "71px", width: "150px" };
  } else if (entity.includes("legrand")) {
    logo = LegrandLogo;
    logoStyle = { height: "200px", width: "auto" };
  }
  else {
    logo = LegrandLogo;
    logoStyle = { height: "200px", width: "auto" };
  }

  return (
    <>


      <SweetAlert
        show={show}
        title={<span style={{ fontSize: "1rem" }}>{title}</span>}
        onConfirm={onConfirm}
        confirmBtnBsStyle={type}
        confirmBtnCssClass="sweetButton"
        customClass='sweetWidth'
        type={type}>
      </SweetAlert>
      {!captchaVerified ? (
        <div
          className="container d-flex justify-content-center align-items-center"
          style={{ minHeight: "100vh" }}
        >
          <div
            className="card p-4 shadow"
            style={{
              width: "450px",
              borderRadius: "10px"
            }}
          >
            <h4 className="text-center mb-3">
              Verify CAPTCHA
            </h4>

            <div className="text-center">

              <canvas
                ref={captchaCanvasRef}
                width={250}
                height={80}
                style={{
                  border: "1px solid #ccc",
                  borderRadius: "5px"
                }}
              />

              <div className="mt-2">
                <button
                  className="btn btn-sm btn-secondary"
                  onClick={() => {
                    generateCaptcha();
                    setEnteredCaptcha("");
                  }}
                >
                  ↻ Refresh CAPTCHA
                </button>
              </div>

            </div>

            <input
              type="text"
              className="form-control mt-3"
              placeholder="Enter CAPTCHA"
              value={enteredCaptcha}
              onChange={(e) =>
                setEnteredCaptcha(e.target.value)
              }
            />

            <button
              className="btn btn-primary mt-3"
              onClick={verifyCaptcha}
            >
              Verify
            </button>
          </div>
        </div>
      ) : (
      <div style={{ backgroundColor: "#f9f9f9", minHeight: "100vh" }}>
        <div style={{
          backgroundColor: "#ffffff",
          padding: "0px 25px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          height: "70px",
          minHeight: "70px",
          maxHeight: "70px",
          boxShadow: "0 2px 8px rgba(0, 0, 0, 0.06)" // slight elevation
        }}>
          {/* <div style={{ display: "flex", alignItems: "center" }}>
            <img
              src={require("../../assets/icons/enmovil.png")} 
              alt="Enmovil Logo"
              style={{ height: "30px", marginRight: "10px" }}
            />

          </div> */}
          {selectedRecord?.truck_seal_entity && logo && (
            <div style={{ display: "flex", alignItems: "center" }}>
              <a className="text-dark">
                <img
                  className="align-self-center pull-right mr-2"
                  style={logoStyle}
                  src={logo}
                  alt="header-browser"
                />
              </a>
            </div>)}



        </div>

        <div className="container-fluid px-3 px-md-5">
          {/* Header + Search + View Options */}
          <div className="row align-items-center justify-content-between mb-3">
            <div className="col-6 col-md-6">
              <h5 className="tracking-head d-flex align-items-center">
                <i className="icofont icofont-vehicle-delivery-van cus-i me-2"></i>
                Tracking Link
              </h5>
            </div>

            {/* <div className="col-6 col-md-6 d-flex flex-wrap justify-content-md-end align-items-center gap-3">
              <div>
                <label className="radio-button" style={{ fontSize: "14px", color: "#333" }}>
                  <input type="radio" name="viewOption" className="me-1" value="invoice" checked={viewOption === "invoice"} onClick={handleViewChange} />
                  Invoice View
                </label>
                <label className="radio-button" style={{ fontSize: "14px", color: "#333" }}>
                  <input type="radio" name="viewOption" className="me-1" value="lr" checked={viewOption === "lr"} onClick={handleViewChange} />
                  LR View
                </label>
              </div>
              <div style={{ position: "relative" }} className="radio-labels">
                <input
                  type="text"
                  className="form-control"
                  style={{
                    border: "1px solid #cccccc",
                    borderRadius: "4px",
                    height: "35px",
                    fontSize: "12px",
                    paddingLeft: "6px",
                    width: "160px"
                  }}
                  onChange={(e) => viewOption === "invoice" ? setInvoiceNo(e.target.value) : setLrNo(e.target.value)}
                  value={viewOption === "invoice" ? invoiceNo : lrNo}
                  placeholder={viewOption === "invoice" ? "Search Invoice No." : "Search LR No."}
                />
                <img
                  src={SearchIcon}
                  className="search_icon"
                  style={{
                    position: "absolute",
                    right: "8px",
                    top: "7px",
                    cursor: "pointer"
                  }}
                  onClick={fetchAndLogDetails} />
              </div>


            </div> */}
          </div>

          {/* Card Container */}
          <div className="row justify-content-center">
            <div className="col-xl-11 col-lg-11 col-md-11 col-sm-12">
              <div
                className="card"
                style={{
                  borderRadius: "10px",
                  overflow: "hidden",
                  boxShadow: "0 4px 12px rgba(0,0,0,0.08)"
                }}
              >
                {/* Top Blue Strip */}
                <div
                  className="d-none d-md-flex"
                  style={{
                    backgroundColor: "#1D7C9C",
                    color: "#fff",
                    padding: "15px 20px",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    fontWeight: "600",
                    fontSize: "16px"
                  }}
                >
                  <div>
                    Tracking ID: <span style={{ fontWeight: "700" }}>{trackingId}</span>
                  </div>
                  <div>
                    Transporter Name: <span style={{ fontWeight: "700" }}>{showInvoiceDetails.transporter_name}</span>
                  </div>
                  <div>
                    POD Status:
                    <span style={{ fontWeight: "700" }}> {showInvoiceDetails.pod_status}</span>
                  </div>
                  {/* <div>
                    Estimated Delivery Date: <span style={{ fontWeight: "700" }}>{getHyphenDDMMMYYYYHHMM(estimatedETA)}</span>
                  </div> */}
                  <div>
                    Estimated Delivery Date:{" "}
                    <span style={{ fontWeight: "700" }}>
                      {actualDeliveryDate
                        ? getHyphenDDMMMYYYYHHMM(actualDeliveryDate)
                        : deliveryDate
                          ? getHyphenDDMMMYYYYHHMM(deliveryDate)
                          : getHyphenDDMMMYYYYHHMM(estimatedETA)}
                    </span>
                  </div>


                </div>

                <div className="d-none d-md-block">

                  <div className="card-body px-3 px-md-4 pt-4">
                    <div className="row">
                      {/* ✅ Desktop view: Horizontal timeline + Table */}
                      <div className="tracking-strip mb-4">

                        {validStatus.length > 0 && validStatus?.map((defaultStatus, index) => {
                          const isLast = index === validStatus.length - 1;

                          // Normalize comparison
                          const normalizeStatus = (status) =>
                            status?.replace(/[\s-]/g, "").toLowerCase();


                          console.log(updatedStatus, "updatedStatus");

                          const lastCompletedIndex = validStatus.findIndex(
                            status => normalizeStatus(status) === normalizeStatus(updatedStatus)
                          );


                          // Match latest event for this status
                          const matchingEvents = timelineData.filter(item => {
                            const normalizedItemStatus = normalizeStatus(item.status || item.intransit_status);
                            const normalizedDefaultStatus = normalizeStatus(defaultStatus);

                            if (normalizedDefaultStatus === "delivered") {
                              if (normalizedItemStatus.includes("undelivered")) {
                                return false
                              } else if (normalizedItemStatus.includes("delivered")) {
                                return true
                              } else {
                                return false
                              }
                            }

                            if (["intransit", "arrivedatdestination"].includes(normalizedDefaultStatus)) {
                              return normalizedItemStatus.includes(normalizedDefaultStatus);
                            }

                            if (normalizedDefaultStatus === "dispatchedfromsource") {
                              return (
                                normalizedItemStatus === "dispatchedfromsource" ||
                                normalizedItemStatus === "tripcreated"
                              );
                            }

                            return normalizedItemStatus.includes(normalizedDefaultStatus);
                          });

                          if (
                            (["intransit", "arrivedatdestination"].includes(normalizeStatus(defaultStatus)) ||
                              normalizeStatus(defaultStatus) === "undelivered") &&
                            matchingEvents.length === 0
                          ) {
                            return null; // No icon, no timeline item
                          }


                          const latestEvent = matchingEvents.length > 0
                            ? matchingEvents.reduce((latest, current) =>
                              new Date(current.transitdatetime) > new Date(latest.transitdatetime) ? current : latest
                            )
                            : null;

                          const isCompleted = latestEvent !== null;

                          // console.log(lastCompletedIndex, "lastCompletedIndex");

                          // Determine next status
                          let connectorClass = "status-connector-gray";
                          let icon = statusImageMapInactive[defaultStatus.toLowerCase()];
                          if (index < lastCompletedIndex) {
                            icon = statusImageMap[defaultStatus.toLowerCase()]
                            connectorClass = "status-connector-green"; // Green up to the second-last completed
                          } else if (index === lastCompletedIndex && normalizeStatus(defaultStatus) === "delivered") {
                            icon = statusImageMap[defaultStatus.toLowerCase()]
                            connectorClass = "status-connector-green"; // Green connector at "Delivered"
                          } else if (index === lastCompletedIndex) {
                            icon = statusImageMap[defaultStatus.toLowerCase()]

                          }
                          const normalizedDefaultStatus = normalizeStatus(defaultStatus);
                          return (
                            <div className="status-step" key={index}>
                              {!isLast && <div className={connectorClass}></div>}

                              <div className="status-label">{defaultStatus}</div>

                              <div className={`status-icon-wrapper ${isCompleted ? 'status-done' : ''}`}>
                                <img src={icon} alt={defaultStatus} className="status-icon" />

                              </div>


                              {/* <div className="status-subtext">
                                {index <= lastCompletedIndex ? (
                                  index === lastCompletedIndex ? (
                                    <>
                                      {getHyphenDDMMMYYYYHHMM(eventDateNTime)} <br />
                                      Location: {eventLocation}
                                    </>
                                  ) : latestEvent ? (
                                    <>
                                      {getHyphenDDMMMYYYYHHMM(latestEvent.transitdatetime)} <br />
                                      Location: {latestEvent.intransit_location}
                                    </>
                                  ) : (
                                    <>-</>
                                  )
                                ) : (
                                  <>-</>
                                )}
                              </div> */}

                              {/* <div className="status-subtext">
                                {latestEvent && index <= lastCompletedIndex ? (
                                  <>
                                    {getHyphenDDMMMYYYYHHMM(latestEvent.transitdatetime)} <br />
                                    Location: {latestEvent.intransit_location}
                                  </>
                                ) : (
                                  <>-</>
                                )}
                              </div> */}
                              <div className="status-subtext">
                                {latestEvent && (
                                  index <= lastCompletedIndex ||
                                  (
                                    normalizedDefaultStatus === "dispatchedfromsource" &&
                                    normalizeStatus(updatedStatus) === "tripcreated"
                                  )
                                ) ? (
                                  <>
                                    {getHyphenDDMMMYYYYHHMM(latestEvent.transitdatetime)} <br />
                                    Location: {latestEvent.intransit_location}
                                  </>
                                ) : (
                                  <>-</>
                                )}
                              </div>


                              {/* <div>
                                {normalizeStatus(defaultStatus) === "delivered" && (

                                  <i
                                    className={`fa fa-eye f17 mt-1 ${showInvoiceDetails.pod_status === "Yes" ? "text-primary" : "text-muted"
                                      }`}
                                    title={
                                      showInvoiceDetails.pod_status === "Yes"
                                        ? "View POD"
                                        : "POD Not Available"
                                    }
                                    onClick={onShowPod}
                                  ></i>

                                )}
                              </div> */}

                              {/* <div className="pod-eye-icon">
                                {normalizeStatus(defaultStatus) === "delivered" && (
                                  <button
                                    className={`btn btn-sm mt-1 ${showInvoiceDetails.pod_status === "Yes" ? "btn-primary" : "btn-secondary"}`}
                                    onClick={onDownloadPod}
                                    disabled={showInvoiceDetails.pod_status !== "Yes"}
                                    title={showInvoiceDetails.pod_status === "Yes" ? "Download POD" : "POD Not Available"}
                                  >
                                    Download POD
                                  </button>
                                )}
                              </div> */}
                              {/* <div className="pod-eye-icon">
                                {normalizeStatus(defaultStatus) === "delivered" &&
                                  showInvoiceDetails.pod_status === "Yes" && (
                                    <button
                                      className="btn btn-sm mt-1 btn-primary"
                                      onClick={onDownloadPod}
                                      title="Download POD"
                                    >
                                      Download POD
                                    </button>
                                  )}
                              </div> */}
                              {/* <div className="pod-eye-icon">
                                {entityType?.toUpperCase() !== "NUMERIC" &&
                                  normalizeStatus(defaultStatus) === "delivered" &&
                                  showInvoiceDetails.pod_status === "Yes" && (
                                    <button
                                      className="btn btn-sm mt-1 btn-primary"
                                      onClick={onDownloadPod}
                                      title="Download POD"
                                    >
                                      Download POD
                                    </button>
                                  )}
                              </div> */}
                              <div className="pod-eye-icon">
                                {entityType?.toUpperCase() !== "NUMERIC" &&
                                  viewOption !== "invoice" &&
                                  normalizeStatus(defaultStatus) === "delivered" &&
                                  showInvoiceDetails.pod_status === "Yes" && (
                                    <button
                                      className="btn btn-sm mt-1 btn-primary"
                                      onClick={onDownloadPod}
                                      title="Download POD"
                                    >
                                      Download POD
                                    </button>
                                  )}
                              </div>



                            </div>
                          );
                        })}
                      </div>

                      <div className="d-flex mb-3">
                        <button
                          className={`btn mr-2 me-2 ${activeTab === "tracking"
                            ? "btn-primary text-white"
                            : "btn-outline-primary"
                            }`}
                          onClick={() => setActiveTab("tracking")}
                        >
                          Tracking Details
                        </button>
                        <button
                          className={`btn ${activeTab === "invoice"
                            ? "btn-primary text-white"
                            : "btn-outline-primary"
                            }`}
                          onClick={() => setActiveTab("invoice")}
                        >
                          Invoice Details
                        </button>
                      </div>
                      {activeTab === "tracking" && (
                        <div className="tracking-card">
                          <div className="tracking-table-wrapper">
                            {/* <table className="tracking-table">
                            <thead>
                              <tr>
                                <th>Status</th>
                                <th>Location</th>
                                <th>Date & Time</th>
                              </tr>
                            </thead>
                            <tbody>
                              {timelineData
                                .slice()
                                .reverse()
                                .map((event, idx) => (
                                  <tr key={idx} className={idx === 0 ? "highlight-row" : ""}>
                                    <td className="status-cell">
                                      <span className="status-dot-space">
                                        {idx === 0 && <span className="status-dot" />}
                                      </span>
                                    
                                      {event.intransit_status}
                                    </td>


                                    <td>{event.intransit_location}</td>
                                    <td>{getHyphenDDMMMYYYYHHMM(event.transitdatetime)}</td>
                                  </tr>
                                ))}
                            </tbody>
                          </table> */}
                            {/* <table className="tracking-table"> */}
                            {/* <thead>
                              <tr>
                                <th>Status</th>
                                <th>Location</th>
                                <th>Date & Time</th>
                                <th>Remarks</th>
                              </tr>
                            </thead> */}
                            {/* <tbody> */}
                            {/* {timelineData */}
                            {/* .slice()
                                .reverse()
                                .map((event, idx) => {
                                  const isInTransit = event.intransit_status === "In Transit";
                                  const hasLegs = Array.isArray(event.legs) && event.legs.length > 0;
                                  const isExpanded = expandedLegsIndex === idx; */}
                            {/* return ( */}
                            {/* <React.Fragment key={idx}> */}
                            {/* <tr className={idx === 0 ? "highlight-row" : ""}>
                                        <td className="status-cell">
                                          <span className="status-dot-space">
                                            {idx === 0 && <span className="status-dot" />}
                                          </span>
                                          {event.intransit_status}
                                          {isInTransit && hasLegs && (
                                            <div
                                              className="expand-legs-icon"
                                              title={isExpanded ? "Collapse Legs" : "Expand Legs"}
                                              style={{
                                                cursor: "pointer",
                                                marginTop: "5px",
                                                color: "#28a745",
                                              }}
                                              onClick={() =>
                                                setExpandedLegsIndex(isExpanded ? null : idx)
                                              }
                                            >
                                              {isExpanded ? "▼ Hide Details" : "▶ Show Details"}
                                            </div>
                                          )}
                                        </td>
                                        <td>{event.intransit_location}</td>
                                        <td>{getHyphenDDMMMYYYYHHMM(event.transitdatetime)}</td>
                                        <td>{event.remarks}</td>
                                      </tr> */}

                            {/* {isExpanded && hasLegs && (
                                        <tr>
                                          <td colSpan="3">
                                            <div className="legs-container">
                                              {event.legs.map((leg, i) => (
                                                <div key={i} className="leg-details">
                                                  <p><strong>Location:</strong> {leg.intransit_location}</p>
                                                  <p><strong>Status:</strong> {leg.intransit_status}</p>
                                                  <p><strong>Date & Time:</strong> {moment(leg.transitdatetime).format("DD-MM-YYYY HH:mm")}</p>
                                                </div>
                                              ))}
                                            </div>
                                          </td>
                                        </tr>
                                      )} */}
                            {/* {isExpanded && hasLegs && (
                                        <tr>
                                          <td colSpan="3">
                                            <div className="legs-container">
                                              <div className="legs-scroll-wrapper">
                                                {event.legs.map((leg, i) => (
                                                  <div key={i} className="leg-details">
                                                    <p><strong>Location:</strong> {leg.intransit_location}</p>
                                                    <p><strong>Status:</strong> {leg.intransit_status}</p>
                                                    <p><strong>Time:</strong> {moment(leg.transitdatetime).format("DD-MM-YYYY HH:mm")}</p>
                                                  </div>
                                                ))}
                                              </div>
                                            </div>
                                          </td>
                                        </tr>
                                      )} */}

                            {/* </React.Fragment> */}
                            {/* ); */}
                            {/* })} */}
                            {/* </tbody> */}
                            {/* </table> */}
                            <div className="tracking-grid">
                              <div className="tracking-grid-header">
                                <div>Status</div>
                                <div>Location</div>
                                <div>Date & Time</div>
                                <div>Remarks</div>
                              </div>
                              {timelineData
                                .slice()
                                .reverse()
                                .map((event, idx) => {
                                  const isInTransit = event.intransit_status === "In Transit";
                                  const hasLegs = Array.isArray(event.legs) && event.legs.length > 0;
                                  const isExpanded = expandedLegsIndex === idx;
                                  return (
                                    <React.Fragment key={idx}>
                                      <div className={`tracking-grid-row ${idx === 0 ? "highlight-row" : ""}`}>
                                        <div className="status-content">
                                          <span className="status-dot-space">
                                            {idx === 0 && <span className="status-dot" />}
                                          </span>
                                          {event.intransit_status}
                                        </div>
                                        <div>{event.intransit_location}</div>
                                        <div className="date-cell">
                                          {getHyphenDDMMMYYYYHHMM(event.transitdatetime)}
                                        </div>
                                        <div>{event.remarks}</div>
                                      </div>
                                      {isExpanded && hasLegs && (
                                        <div className="tracking-grid-expand">
                                          {event.legs.map((leg, i) => (
                                            <div key={i} className="leg-details">
                                              <p><strong>Location:</strong> {leg.intransit_location}</p>
                                              <p><strong>Status:</strong> {leg.intransit_status}</p>
                                              <p><strong>Time:</strong> {moment(leg.transitdatetime).format("DD-MM-YYYY HH:mm")}</p>
                                            </div>
                                          ))}
                                        </div>
                                      )}
                                    </React.Fragment>
                                  );
                                })}
                            </div>
                          </div>
                        </div>
                      )}
                      {activeTab === "invoice" && (
                        <div className="tracking-grid">
                          <div className="tracking-grid-header">
                            <div>Invoice No</div>
                            <div>Invoice Date</div>
                          </div>
                          {
                            viewOption === "invoice" ? (
                              <div className="tracking-grid-row">
                                <div>{selectedRecord?.invoice_no || "-"}</div>
                                <div>
                                  {selectedRecord?.invoice_time
                                    ? getHyphenDDMMMYYYYHHMM(
                                      selectedRecord.invoice_time
                                    )
                                    : "-"}
                                </div>
                              </div>
                            ) : (
                              Array.isArray(selectedRecord?.invoice_list) &&
                                selectedRecord.invoice_list.length > 0 ? (
                                selectedRecord.invoice_list.map(
                                  (inv, index) => (
                                    <div
                                      className="tracking-grid-row"
                                      key={index}
                                    >
                                      <div>{inv}</div>
                                      <div>
                                        {selectedRecord?.invoice_time
                                          ? getHyphenDDMMMYYYYHHMM(
                                            selectedRecord.invoice_time
                                          )
                                          : "-"}
                                      </div>
                                    </div>
                                  )
                                )
                              ) : (
                                <div className="tracking-grid-row">
                                  <div>-</div>
                                  <div>-</div>
                                </div>
                              )
                            )
                          }
                        </div>
                      )}
                    </div>





                  </div>
                </div>
                {/* ✅ Mobile view: Vertical timeline only */}
                <div className="d-block d-md-none">
                  <div className="mobile-timeline-card">
                    {/* Header */}
                    <div className="timeline-heading">Consignment Tracking Timeline</div>

                    {/* Light blue ETA bar */}
                    <div className="eta-strip">
                      Tracking ID: {trackingId}
                    </div>
                    <div className="eta-strip">
                      Estimated Delivery Date: {getHyphenDDMMMYYYYHHMM(estimatedETA)}
                    </div>
                    <div className="eta-strip">
                      Transporter Name: {showInvoiceDetails.transporter_name}
                    </div>
                    <div className="eta-strip">
                      POD Status: {showInvoiceDetails.pod_status}
                    </div>


                    {/* Timeline Steps */}
                    <div className="mobile-tracking-timeline">

                      {reversedValidStatus.map((defaultStatus, index) => { // Reverse the order here
                        const isLast = index === reversedValidStatus.length - 1;

                        // Normalize status matching
                        const matchingEvents = reversedTimelineData.filter(item => {  // Reverse the data here
                          const normalizedItemStatus = normalizeStatus(item.intransit_status);
                          const normalizedDefaultStatus = normalizeStatus(defaultStatus);

                          return normalizedDefaultStatus === "delivered"
                            ? normalizedItemStatus.includes("undelivered")
                              ? false
                              : normalizedItemStatus.includes("delivered")
                                ? true
                                : false
                            : normalizedItemStatus.includes(normalizedDefaultStatus);

                        });

                        if (
                          (["intransit", "arrivedatdestination"].includes(normalizeStatus(defaultStatus)) ||
                            normalizeStatus(defaultStatus) === "undelivered") &&
                          matchingEvents.length === 0
                        ) {
                          return null; // No icon, no timeline item
                        }

                        const lastCompletedIndex = reversedValidStatus.findIndex(
                          status => normalizeStatus(status) === normalizeStatus(updatedStatus)
                        );



                        const latestEvent = matchingEvents.length > 0
                          ? matchingEvents.reduce((latest, current) =>
                            new Date(current.transitdatetime) > new Date(latest.transitdatetime) ? current : latest
                          )
                          : null;


                        const isCompleted = latestEvent !== null;

                        let connectorClass = "status-connector-gray-mobile";
                        let icon = statusImageMapInactive[defaultStatus.toLowerCase()];
                        if (index > lastCompletedIndex) {
                          icon = statusImageMap[defaultStatus.toLowerCase()];
                          connectorClass = "status-connector-green-mobile"; // Green up to the second-last completed
                        } else if (index === lastCompletedIndex && normalizeStatus(defaultStatus) === "delivered") {
                          icon = statusImageMap[defaultStatus.toLowerCase()];
                          connectorClass = "status-connector-green-mobile"; // Green connector at "Delivered"
                        } else if (index === lastCompletedIndex) {
                          icon = statusImageMap[defaultStatus.toLowerCase()];
                          connectorClass = "status-connector-green-mobile"; // Green connector at "Delivered"

                        }

                        return (
                          <>
                            {/* {normalizeStatus(defaultStatus) === "delivered" && (
          <div className="pod-eye-icon">
            <i
              className={`fa fa-eye f17 mt-1 ${showInvoiceDetails.pod_status === "Yes" ? "text-primary" : "text-muted"}`}
              title={showInvoiceDetails.pod_status === "Yes" ? "View POD" : "POD Not Available"}
              onClick={onShowPod}
            ></i>
          </div>
        )} */}
                            {entityType?.toUpperCase() !== "NUMERIC" &&
                              viewOption !== "invoice" &&
                              normalizeStatus(defaultStatus) === "delivered" &&
                              showInvoiceDetails.pod_status === "Yes" && (
                                <div className="pod-eye-icon">
                                  <button
                                    className="btn btn-sm mt-1 btn-primary"
                                    onClick={onDownloadPod}
                                    title="Download POD"
                                  >
                                    Download POD
                                  </button>
                                </div>
                              )}

                            <div className="timeline-row" key={index}>
                              {/* Left: Status */}
                              <div className="timeline-left">
                                <div className="step-title">{defaultStatus}</div>
                              </div>


                              {/* Center: Icon + connector */}
                              <div className="timeline-center">

                                <div>
                                  <img src={icon} alt={defaultStatus} className="status-icon" />
                                </div>
                                {!isLast && <div className={connectorClass}></div>}

                              </div>

                              {/* Right: Date & Location */}
                              <div className="timeline-right">
                                <div className="step-datetime">
                                  {index >= lastCompletedIndex ? (
                                    index === lastCompletedIndex ? (
                                      <>{getHyphenDDMMMYYYYHHMM(eventDateNTime)}</>
                                    ) : (
                                      <>{latestEvent ? getHyphenDDMMMYYYYHHMM(latestEvent.transitdatetime) : ""}</>
                                    )
                                  ) : (
                                    ""
                                  )}
                                </div>

                                <div className="step-location">
                                  {index >= lastCompletedIndex ? (
                                    index === lastCompletedIndex ? (
                                      <>Location: {eventLocation}</>
                                    ) : (
                                      <>{latestEvent ? `Location: ${latestEvent.intransit_location}` : ""}</>
                                    )
                                  ) : (
                                    ""
                                  )}
                                </div>
                              </div>
                            </div>
                          </>
                        );
                      })}
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row justify-content-end poweredByLogo">
          <div class="">
            <img src={PoweredByEnmovil} alt="" />
          </div>
        </div>
      </div>
)}
      {/* <h4>Consignment Code - {consignmentNum}</h4> */}

    </>
  );
};

export default TrackingConsignments;
